import { AlertActionTypes } from 'util/modules/Alert/redux/types'
/**
* Data Types
*/

import { PaginationOpts } from 'util/types/index'

export type BalanceType = (
  'TAX_APP' | 'TAX_CARD' | 'MONTHLY' |
  'RECEIVE' | 'DELIVERY' | 'PERSONAL' |
  'MONEY' | 'IN-APP' | 'CREDIT' | 'DEBIT'
)

export interface Balance {
  id: number,
  type: BalanceType,
  amount: number,
  description: string,
  createdAt: string
}

export interface Payment {
  reference: number,
  type: BalanceType,
  description: string,
  amount: number,
  createdAt: string,
  from: string,
  to: string,
  children: Payment[]
}

/**
* State Type
*/

export interface BalanceState {
  readonly balance: number
  readonly balanceList: { items: Balance[], pagination?: PaginationOpts }
  readonly types: { [x: string]: string }
  readonly payments: Payment[]
}

/**
* Action Enum Types
*/

export enum BalanceTypes {
  BALANCE_GET = 'BALANCE/GET',
  BALANCE_LIST = 'BALANCE/LIST',
  PAYMENT_LIST = 'PAYMENT/LIST'
}

/**
* Action Types
*/
interface GetBalance {
  type: typeof BalanceTypes.BALANCE_GET,
  payload: number
}

interface GetBalanceList {
  type: typeof BalanceTypes.BALANCE_LIST,
  payload: Balance[]
  pagination?: PaginationOpts
}

interface GetPaymentList {
  type: typeof BalanceTypes.PAYMENT_LIST,
  payload: Payment[]
}

export type BalanceActionTypes = (
  AlertActionTypes | GetBalance | GetBalanceList | GetPaymentList
)
